export default function ErrorSuccessModal(props){
    return (
<div
  className="modal fade text-left show"
  id="verify_modal"
  tabIndex={-1}
  role="dialog"
  style={{ display: "block", paddingRight: 15, zIndex:999,position:"fixed",inset:0,backgroundColor:'rgba(0, 0, 0, 0.9)' }}
>
  <div
    className="modal-dialog modal-dialog-centered modal-dialog-scrollable"
    role="document"
  >
    <div className="modal-content">
      <div className={`modal-header bg-${props.title === 'Success' ? 'success' : 'danger'}`}>
        <h6 className="modal-title">{props.title}</h6>
        <button
          type="button"
          className="close"
          data-dismiss="modal"
          aria-label="Close"
          onClick={() => props.closeModal(props.title === 'Success' ? 'Success' : 'Error')}
        >
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div className="modal-body">
        <strong>Message: {props.msg}</strong>
        <br />
      </div>
      <div className="modal-footer">
        <button
          className="btn btn-primary"
          onClick={() => props.closeModal(props.title === 'Success' ? 'Success' : 'Error')}
        >
          Close
        </button>
      </div>
    </div>
  </div>
</div>
    );
}